import { render, staticRenderFns } from "./xsjl.vue?vue&type=template&id=0fba89e1&scoped=true"
import script from "./xsjl.vue?vue&type=script&lang=js"
export * from "./xsjl.vue?vue&type=script&lang=js"
import style0 from "./xsjl.vue?vue&type=style&index=0&id=0fba89e1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!E:\\SAAS-QSX\\qsx-web\\node_modules\\_vue-loader@15.11.1@vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fba89e1",
  null
  
)

export default component.exports